import { createContext, useContext, useMemo, useState } from 'react'

// Shared "which riders are ticked for comparison" state, lifted above
// Results/All Runs/Compare so a selection made on either listing page
// survives navigating to Compare. Keyed by race number - good enough since
// a race number is unique within one event's field.
const SelectionContext = createContext(null)

export function SelectionProvider({ children }) {
  const [selected, setSelected] = useState(() => new Set())

  const api = useMemo(
    () => ({
      selected,
      isSelected: (num) => selected.has(num),
      toggle: (num) =>
        setSelected((prev) => {
          const next = new Set(prev)
          next.has(num) ? next.delete(num) : next.add(num)
          return next
        }),
      clear: () => setSelected(new Set()),
    }),
    [selected],
  )

  return <SelectionContext.Provider value={api}>{children}</SelectionContext.Provider>
}

export function useSelection() {
  const ctx = useContext(SelectionContext)
  if (!ctx) throw new Error('Must be used within <SelectionProvider>')
  return ctx
}
